import styled from 'styled-components';

export const ChallengeStyled = styled.div`
  margin: 90px 0;
`;

export const Inner = styled.div`
  background: var(--dblue);
  .container {
    padding: 90px 20px;
    display: flex;
    flex-direction: column;
  }
`;

export const HeadLine = styled.h2`
  color: var(--white);
  font-family: Rubik;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
`;

export const ChallengeSolution = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 65px;
  @media (min-width: 992px) {
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 72px;
  }
`;

export const ChallengeBlock = styled.div`
  box-sizing: border-box;
  border-radius: 20px;
  h3 {
    color: var(--white);
    font-family: Rubik;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 40px;
  }
  > div {
    color: var(--white);
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 22px;
    strong {
      font-weight: bold;
    }
  }
  @media (min-width: 992px) {
    background: var(--blue);
    max-width: 360px;
    padding: 40px;
  }
`;

export const SolutionBlock = styled.div`
  box-sizing: border-box;
  margin-top: 64px;
  h3 {
    color: var(--white);
    font-family: Rubik;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 40px;
  }
  > div {
    color: var(--white);
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 22px;
    strong {
      font-weight: bold;
    }
  }
  @media (min-width: 992px) {
    max-width: 648px;
    margin-top: 0;
    padding: 40px;
  }
`;
